var Autopilot = {
	landmarks:[],
	pos:0,
	initialized: false,
	running: false,
	speed: 3,
	speedAutoClose: null,

	init: function() {
		AppEvent.on(player, "mouseDown",Autopilot.pause);
	},

	setRoute: function(marks) {
		Autopilot.landmarks = marks;
		if (!Autopilot.initialized) {
			Autopilot.initialized = true;
			AppEvent.on(player, "PLACE.LOADED", Autopilot.onPlaceLoad);

			$("#overlay").append(TPL.render("autoplay-main", {"pdown": "on" + Events.pointer.down}));

			Autopilot.button = $("#autoplay_icon");
			Autopilot.speedbutton = $("#autoplay_speed");
			Autopilot.stopbutton = $("#autoplay_back");

			//Autopilot.button.on(Events.pointer.down, Autopilot.pause);
			Autopilot.button.on(Events.pointer.down, Autopilot.toggle);
			Autopilot.speedbutton.on(Events.pointer.down, Autopilot.selectspeed);
			Autopilot.stopbutton.on(Events.pointer.down, Autopilot.stop);
		}
	},

	onPlaceLoad: function(place) {
		if (Autopilot.running) {
			setTimeout(Autopilot.cycle, Autopilot.speed * 1000);
		}
	},

	start: function() {
		Autopilot.pos = 0;
		Autopilot.running = true;
		player.bottomBar(false);
		$("#autoplay_box").show();

		setTimeout(function() {
			ssi("Plan", "plantoid", {"planspot": Autopilot.landmarks[Autopilot.pos]}, function(resp) {
				if (resp.data > 0) player.go(resp.data, 0);
				else Autopilot.cycle();
			});
			//player.go(Autopilot.landmarks[Autopilot.pos], 0);
		}, 200);


	},

	toggle: function() {
		if (Autopilot.running) Autopilot.pause(); 
		else Autopilot.resume();
	},

	pause: function() {
		if (Autopilot.running) {
			Autopilot.running = false;
			//player.bottomBar(true);
			Autopilot.button.html("<span>" + TPL.lng("autopilot.resume", "Wznów") + "</span><img src='assets/play.png'>");
			Autopilot.button.removeClass("auto_running");

			player.currentView.stopTurning();
			//$("#autoplay_icon").hide();

			$("#big_pause").show();
			$("#big_pause").removeClass("big_fade");
			setTimeout(function() {$("#big_pause").addClass("big_fade");}, 100);
		}
	},

	resume: function() {
		Autopilot.running = true;
		//player.bottomBar(false);
		Autopilot.button.html("<span>" + TPL.lng("autopilot.stop", "Zatrzymaj") + "</span><img src='assets/pause.png'>");
		Autopilot.button.addClass("auto_running");
		Autopilot.cycle();
		//$("#autoplay_icon").show();

		$("#big_play").show();
		$("#big_play").removeClass("big_fade");
		setTimeout(function() {$("#big_play").addClass("big_fade");}, 100);
	},

	stop: function() {
		Autopilot.running = false;
		player.bottomBar(true);
		$("#autoplay_box").hide();
	},

	selectspeed: function() {
		$("#autoplay_speedlist").toggle();

		if (Autopilot.speedAutoClose != null) clearTimeout(Autopilot.speedAutoClose);

		if ($("#autoplay_speedlist").is(":visible")) {
			Autopilot.speedAutoClose = setTimeout(function() {$("#autoplay_speedlist").hide();}, 10000);
		} else {
			if (Autopilot.speedAutoClose != null) clearTimeout(Autopilot.speedAutoClose);
		}
	},

	setspeed: function(n) {
		$("#autoplay_speedlist").hide();
		Autopilot.speed = n;
		//if (Autopilot.speed > 4) Autopilot.speed = 1;
		switch(Autopilot.speed) {
			case 1:
				Autopilot.speedbutton.html("<img src='assets/speed4.png'><span>Prędkość:<Br><b>" + TPL.lng("autopilot.very_fast", "b. szybko") + "</b></span>");
			break;
			case 2:
				Autopilot.speedbutton.html("<img src='assets/speed3.png'><span>Prędkość:<Br><b>" + TPL.lng("autopilot.fast", "szybko") + "</b></span>");
			break;
			case 3:
				Autopilot.speedbutton.html("<img src='assets/speed2.png'><span>Prędkość:<Br><b>" + TPL.lng("autopilot.very_slow", "wolno") + "</b></span>");
			break;
			case 4:
				Autopilot.speedbutton.html("<img src='assets/speed1.png'><span>Prędkość:<Br><b>" + TPL.lng("autopilot.very_slow", "b. wolno") + "</b></span>");
			break;
		}
	},

	cycle: function() {
		if (!Autopilot.running) return;

		Autopilot.pos ++;
		if (Autopilot.pos < Autopilot.landmarks.length) {
			ssi("Plan", "plantoid", {"planspot": Autopilot.landmarks[Autopilot.pos]}, function(resp) {
//				var hsp = HotSpotManager.findById(Autopilot.landmarks[Autopilot.pos]);
				var hsp = HotSpotManager.findById(resp.data);
				/*
				var lastPos = Autopilot.pos;
				while(hsp == null && Autopilot.pos < Autopilot.landmarks.length) {
					Autopilot.pos ++;
					hsp = HotSpotManager.findById(Autopilot.landmarks[Autopilot.pos]);
				}
				*/

				if (hsp != null) {
					HotSpotManager.findById(resp.data).proceed();
				//	HotSpotManager.findById(Autopilot.landmarks[Autopilot.pos]).proceed();
//				} else if (Autopilot.pos > lastPos) {
				} else {
					//Autopilot.pos = lastPos;
					if (resp.data > 0) player.go(resp.data, 0);
					else Autopilot.cycle();
					//player.go(Autopilot.landmarks[Autopilot.pos], 0);
				/*
				} else {
					player.bottomBar(true);
					$("#autoplay_icon").hide();				
				*/
				}
				//player.go(Autopilot.landmarks[Autopilot.pos], 0);
			});
		} else {
			player.bottomBar(true);
			$("#autoplay_box").hide();
		}
	}
}

PluginManager.add(Autopilot);